import Vue from 'vue';
import Router from 'vue-router';
import pageA from '../views/pageA.vue';
import pageB from '../views/pageB.vue';
import pageC from '../views/pageC.vue';
import pageD from '../views/pageD.vue';
import pageE from '../views/pageE.vue';
import pageF from '../views/pageF.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'main',
      component: pageA,
    },
    {
      path: '/reservation',
      name: 'reservation',
      component: pageB,
    },
    {
      path: '/world',
      name: 'world',
      component: pageC,
    },
    {
      path: '/war',
      name: 'war',
      component: pageD,
    },
    {
      path: '/class',
      name: 'class',
      component: pageE,
    },
    {
      path: '/media',
      name: 'media',
      component: pageF,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js